export {
  isSomeElementSelected,
  getElementsWithinSelection,
  getSelectedElements,
  getTargetElements,
} from "@excalidraw/element";
export { getScrollToContentState } from "../viewport";
export {
  hasBackground,
  hasFillStyle,
  hasRoughness,
  hasStrokeWidth,
  hasStrokeStyle,
  hasFreedrawMode,
  canHaveArrowheads,
  canChangeRoundness,
} from "@excalidraw/element";
export {
  getNormalizedZoom,
  getNormalizedGridSize,
  getNormalizedGridStep,
} from "./normalize";
